(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mercadean-catalog-ui"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mercadean-catalog')) {
  customElements.define('mercadean-catalog', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const cards = this.querySelectorAll('.msc__card');
      const revealAll = () => {
        this.observer?.disconnect();
        cards.forEach(card => card.removeAttribute('data-reveal'));
      };
      revealAll();
      if ('IntersectionObserver' in window && !motion.matches && !window.Shopify?.designMode) {
        try {
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                entry.target.setAttribute('data-reveal', 'visible');
                this.observer.unobserve(entry.target);
              }
            });
          }, { threshold: 0.08 });
          cards.forEach(card => {
            card.setAttribute('data-reveal', 'waiting');
            this.observer.observe(card);
          });
        } catch {
          revealAll();
        }
      }
      motion.addEventListener('change', event => {
        if (event.matches) revealAll();
      }, options);
      this.addEventListener('focusin', event => {
        const card = event.target.closest('.msc__card');
        if (card) {
          card.removeAttribute('data-reveal');
          this.observer?.unobserve(card);
        }
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.querySelectorAll('.msc__card').forEach(card => card.removeAttribute('data-reveal'));
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mercadean-extra-style"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mercadean-extra'))customElements.define('mercadean-extra',class extends HTMLElement{
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();const opts={signal:this.abort.signal};
  const reduce=matchMedia('(prefers-reduced-motion:reduce)');
  if(this.dataset.motion!=='true'||reduce.matches||!this.animate||!('IntersectionObserver' in window))return;
  const reveal=()=>{this.observer?.disconnect();this.motion=this.animate([{opacity:0,transform:'translateY(12px)'},{opacity:1,transform:'translateY(0)'}],{duration:Number(this.dataset.duration)||450,easing:'cubic-bezier(.22,1,.36,1)'});this.motion.onfinish=()=>this.motion=null};
  this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting))reveal()},{threshold:.08});this.observer.observe(this);
  const stop=()=>{this.observer?.disconnect();this.motion?.cancel()};
  reduce.addEventListener('change',stop,opts);this.addEventListener('focusin',stop,opts);this.addEventListener('shopify:block:select',stop,opts);
 }
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.motion?.cancel()}
});
if(!customElements.get('mercadean-compare'))customElements.define('mercadean-compare',class extends HTMLElement{
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();const opts={signal:this.abort.signal};
  const canvas=this.querySelector('.msx__canvas'),input=this.querySelector('input');if(!canvas||!input)return;
  let pointer=null;
  const set=value=>{const pct=Math.max(0,Math.min(100,Number(value)));input.value=String(pct);canvas.style.setProperty('--msx-position',pct+'%');input.setAttribute('aria-valuetext',this.dataset.label+' · '+pct+'%')};
  const point=e=>{const box=canvas.getBoundingClientRect();if(box.width)set((e.clientX-box.left)/box.width*100)};
  canvas.addEventListener('pointerdown',e=>{if(e.isPrimary===false||e.button!==0)return;pointer=e.pointerId;canvas.setPointerCapture(pointer);point(e)},opts);
  canvas.addEventListener('pointermove',e=>{if(e.pointerId===pointer)point(e)},opts);
  const stop=()=>{pointer=null};
  canvas.addEventListener('pointerup',stop,opts);canvas.addEventListener('pointercancel',stop,opts);canvas.addEventListener('lostpointercapture',stop,opts);
  input.addEventListener('input',()=>set(input.value),opts);
  this.querySelectorAll('[data-value]').forEach(button=>button.addEventListener('click',()=>set(button.dataset.value),opts));
  set(this.dataset.initial||50);
 }
 disconnectedCallback(){this.abort?.abort()}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mercadean-fit-heading"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mercadean-fit-heading'))customElements.define('mercadean-fit-heading',class extends HTMLElement{
 connectedCallback(){
  const fit=()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>{
   if(!this.isConnected)return;const span=this.querySelector('span');span.style.fontSize='inherit';
   const available=this.clientWidth,natural=span.getBoundingClientRect().width,size=parseFloat(getComputedStyle(this).fontSize);
   if(available>0&&natural>available)span.style.fontSize=(size*(available-1)/natural)+'px';
  });};
  this.observer?.disconnect();this.observer=new ResizeObserver(fit);this.observer.observe(this.parentElement);
  this.abort?.abort();this.abort=new AbortController();document.fonts.addEventListener('loadingdone',fit,{signal:this.abort.signal});document.fonts.ready.then(fit);fit();
 }
 disconnectedCallback(){this.observer?.disconnect();this.abort?.abort();cancelAnimationFrame(this.frame);}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mercadean-page-motion"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mercadean-page-motion'))customElements.define('mercadean-page-motion',class extends HTMLElement{
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();const options={signal:this.abort.signal};
  this.targets=new Set();this.played=new WeakSet();this.animations=new Map();this.heroes=new Map();
  this.motion=matchMedia('(prefers-reduced-motion:reduce)');
  this.duration=Math.min(1000,Math.max(250,Number(this.dataset.duration)||600));
  this.distance=Math.min(40,Math.max(0,Number(this.dataset.distance)||0));
  this.stagger=Math.min(100,Math.max(0,Number(this.dataset.stagger)||0));
  if(!('IntersectionObserver' in window)||!Element.prototype.animate)return;
  this.observer=new IntersectionObserver(entries=>{
   const visible=entries.filter(e=>e.isIntersecting&&this.eligible(e.target));
   visible.sort((a,b)=>a.target.compareDocumentPosition(b.target)&Node.DOCUMENT_POSITION_FOLLOWING?-1:1);
   visible.forEach((entry,index)=>this.reveal(entry.target,Math.min(index*this.stagger,180)));
  },{threshold:0,rootMargin:'0px 0px -28px 0px'});
  const start=()=>{if(this.isConnected)this.scan();};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{...options,once:true});else start();
  document.addEventListener('shopify:section:load',start,options);
  document.addEventListener('shopify:section:unload',event=>{
   for(const target of this.targets)if(event.target.contains(target)){this.finish(target);this.targets.delete(target);}
   for(const [hero,observer] of this.heroes)if(event.target.contains(hero)){observer.disconnect();this.heroes.delete(hero);}
  },options);
  const revealFocused=event=>{for(const target of this.targets)if(target===event.target||target.contains(event.target))this.finish(target);};
  document.addEventListener('focusin',revealFocused,options);
  document.addEventListener('pointerdown',revealFocused,{...options,passive:true});
  const revealEditorSelection=event=>{for(const target of this.targets)if(event.target.contains(target)||target.contains(event.target))this.finish(target);};
  document.addEventListener('shopify:block:select',revealEditorSelection,options);
  document.addEventListener('shopify:section:select',revealEditorSelection,options);
  this.motion.addEventListener('change',()=>{if(this.motion.matches)this.showAll();else this.scan();},options);
  window.addEventListener('beforeprint',()=>this.showAll(),options);
  // Restore from browser back/forward cache with no stale invisible content.
  window.addEventListener('pageshow',event=>{if(event.persisted)this.showAll();},options);
 }
 eligible(target){
  const slide=target.closest('.mh__slide');
  return !target.closest('[inert]')&&(!slide||slide.classList.contains('is-active'));
 }
 scan(){
  const selectors=[
   '.header__heading-logo-wrapper',
   '.mh__title','.mh__subtitle','.mh__benefit','.mh__action','.mh__controls',
   '.msg__heading','.msg__subtitle','.msg__hint','.msg__card','.msg__pagination',
   '.mig__heading','.mig__button','.mig__stage','.mig__controls',
   '.mct__eyebrow','.mct__heading','.mct__lead','.mct__detail','.mct__whatsapp','.mct__panel',
   '.mf__marquee','.mf__brand','.mf__newsletter','.mf__column','.mf__bottom'
  ];
  document.querySelectorAll(selectors.join(',')).forEach(target=>{
   if(this.targets.has(target))return;this.targets.add(target);
   if(this.motion.matches||target.contains(document.activeElement)){this.finish(target);return;}
   const box=target.getBoundingClientRect();
   // Content already above the restored scroll position must remain readable.
   if(box.bottom<0){this.finish(target);return;}
   target.dataset.mMotion='waiting';this.observer.observe(target);
  });
  document.querySelectorAll('.mh').forEach(hero=>{
   if(this.heroes.has(hero))return;
   const observer=new MutationObserver(()=>{
    const box=hero.getBoundingClientRect();if(box.bottom<0||box.top>innerHeight)return;
    hero.querySelectorAll('.mh__slide.is-active [data-m-motion="waiting"]').forEach((target,index)=>this.reveal(target,Math.min(index*this.stagger,180)));
   });
   observer.observe(hero,{subtree:true,attributes:true,attributeFilter:['class']});this.heroes.set(hero,observer);
  });
  // A paginated card can intersect before its row removes inert. Recheck after settling.
  document.querySelectorAll('.msg__row').forEach(row=>{
   if(row.dataset.motionObserved==='true')return;row.dataset.motionObserved='true';
   row.addEventListener('scroll',()=>{
    for(const target of row.querySelectorAll('[data-m-motion="waiting"]'))if(this.eligible(target)){this.observer.unobserve(target);this.observer.observe(target);}
   },{signal:this.abort.signal,passive:true});
  });
 }
 reveal(target,delay=0){
  if(this.played.has(target)||!this.eligible(target))return;
  if(this.motion.matches){this.finish(target);return;}
  this.played.add(target);this.observer.unobserve(target);target.dataset.mMotion='running';
  const distance=target.matches('.mh__visual picture')?0:(matchMedia('(max-width:749px)').matches?Math.min(this.distance,18):this.distance);
  try{
   const animation=target.animate([{opacity:0,translate:'0 '+distance+'px'},{opacity:1,translate:'0 0'}],{duration:this.duration,delay,easing:'cubic-bezier(.22,.61,.36,1)',fill:'both'});
   this.animations.set(target,animation);
   animation.finished.then(()=>{if(this.animations.get(target)===animation)this.finish(target);}).catch(()=>{});
  }catch{this.finish(target);}
 }
 finish(target){
  this.observer?.unobserve(target);this.played.add(target);target.dataset.mMotion='shown';
  const animation=this.animations.get(target);this.animations.delete(target);animation?.cancel();
 }
 showAll(){for(const target of this.targets)this.finish(target);}
 disconnectedCallback(){
  this.abort?.abort();this.observer?.disconnect();this.heroes?.forEach(observer=>observer.disconnect());
  if(this.targets){this.showAll();for(const target of this.targets)target.removeAttribute('data-m-motion');}
  document.querySelectorAll('[data-motion-observed]').forEach(row=>row.removeAttribute('data-motion-observed'));
 }
});
  } catch(e) { console.error(e); }
})();

})();
